module.exports = __webpack_public_path__ + "img/H0-1200w.15f12624.jpg";